import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import comment from '@comp/comment/comment';
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'FeedBackModal',
  mixins: [ModalFormMixin],
  components: {
    comment: comment,
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '反馈单表单',
      tableName: 'om_feed_back',
      siteName: '',
      siteId: null,
      showCheck: '',
      operationType: '',
      form_fields: ['siteId', 'tel', 'status', 'remark', 'tenantId'],
      form_fields_time: ['feedDate'],
      validatorRules: {
        remark: {
          rules: [{
            required: true,
            message: '请输入问题和意见!'
          }]
        },
        feedDate: {
          rules: [{
            required: true,
            message: '请输入反馈日期!'
          }]
        }
      },
      startUser: null
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
      console.log('siteName', newVal);
    }
  },
  created: function created() {},
  methods: {
    edit: function edit(record) {
      var _this = this;

      // this.model.operationType = this.operationType
      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('enter', this.model);
      this.visible = true;
      this.startUser = {
        key: this.model.createBy,
        label: this.model.createBy_userName
      };

      if (this.model.id) {} else {
        this.model.siteId = this.siteId;
        this.model.feedDate = new Date().toLocaleDateString();
        this.model.siteName = this.siteName;
        this.model.operationType = this.operationType;
        console.log('this.model', this.model);
      } // if (this.model.id) {
      //   // this.siteName = this.model.siteName
      //   this.model.siteId = this.siteId
      // } else {
      //   this.model.feedDate = new Date().toLocaleDateString()
      // }

      /* this.model.siteName = this.siteName
      this.model.siteId = sessionStorage.getItem('siteId')
      this.model.operationType = sessionStorage.getItem('operationType')*/


      this.disableSubmit = this.showCheck ? true : this.disableSubmit;
      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
        that.$refs.iwupload.loadUploadFiles();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.feedDate = formData.feedDate ? formData.feedDate.format('YYYY-MM-DD') : null; // debugger

          formData.siteId = that.model.siteId;
          formData = that.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
            formData.status = 1;
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          if (_this2.showCheck) formData.status = 3;
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};